import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const inputCls = "bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#D4AF37]";

export const SessionEditForm = ({ detail, coaches, isAdmin, onSaved, onCancel }) => {
  const [date, setDate] = useState(detail.date);
  const [coach, setCoach] = useState(detail.coach || "");
  const [marks, setMarks] = useState(Object.fromEntries(detail.rows.map((r) => [r.player_id, r.mark])));
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/attendance/session", {
        date: detail.date, batch: detail.batch, new_date: date, coach: coach || null,
        marks: Object.entries(marks).filter(([, m]) => m !== "T").map(([player_id, mark]) => ({ player_id, mark })),
      });
      toast.success("Session updated");
      onSaved(date);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  return (
    <div data-testid="session-edit-form">
      <div className={`grid gap-3 mb-5 ${isAdmin ? "sm:grid-cols-2" : ""}`}>
        <div>
          <label className="block text-[10px] uppercase tracking-widest text-white/40 font-semibold mb-2">Session Date</label>
          <input type="date" max={new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })} value={date} onChange={(e) => setDate(e.target.value)} className={inputCls + " w-full"} data-testid="session-edit-date" />
        </div>
        {isAdmin && (
          <div>
            <label className="block text-[10px] uppercase tracking-widest text-white/40 font-semibold mb-2">Coach</label>
            <select value={coach} onChange={(e) => setCoach(e.target.value)} className={inputCls + " w-full"} data-testid="session-edit-coach">
              <option value="">— Select coach —</option>
              {coaches.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
              {coach && !coaches.some((c) => c.name === coach) && <option value={coach}>{coach}</option>}
            </select>
          </div>
        )}
      </div>
      <div className="space-y-2">
        {detail.rows.map((r) => (
          <div key={r.player_id} className="flex items-center justify-between border border-white/5 bg-[#050505] px-4 py-2" data-testid={`session-edit-row-${r.player_id}`}>
            <p className="text-sm">{r.name}</p>
            {marks[r.player_id] === "T" ? <span className="text-blue-300 text-[10px] uppercase tracking-widest">Trial</span> : (
              <div className="flex gap-2">
                {["P", "A"].map((m) => (
                  <button key={m} type="button" onClick={() => setMarks({ ...marks, [r.player_id]: m })} data-testid={`session-edit-mark-${r.player_id}-${m}`}
                    className={`w-10 h-9 font-heading font-black text-xs rounded-sm transition-colors duration-150 ${marks[r.player_id] === m ? (m === "P" ? "bg-[#D4AF37] text-black" : "bg-red-500/80 text-white") : "border border-white/15 text-white/40 hover:border-white/40"}`}>{m}</button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="flex gap-3 mt-6">
        <button onClick={save} disabled={busy} className="flex-1 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-6 py-3 rounded-sm hover:bg-[#F3D059] transition-colors duration-200 disabled:opacity-50" data-testid="session-edit-save">{busy ? "Saving..." : "Save Changes"}</button>
        <button onClick={onCancel} className="border border-white/15 text-white/70 uppercase tracking-widest text-xs px-6 py-3 rounded-sm hover:border-white/40 transition-colors duration-200" data-testid="session-edit-cancel">Cancel</button>
      </div>
    </div>
  );
};
